const parseStyleLength = (style: string, property: "width" | "height") => {
  const match = style.match(new RegExp(`${property}\\s*:\\s*([^;]+)`, "i"))
  return match?.[1]?.trim() ?? null
}

export const applyExplicitImageDimensions = (root: ParentNode) => {
  root.querySelectorAll("img").forEach((node) => {
    const img = node as HTMLImageElement
    const inlineStyle = img.getAttribute("style") ?? ""
    const widthFromStyle = parseStyleLength(inlineStyle, "width")
    const heightFromStyle = parseStyleLength(inlineStyle, "height")
    const widthAttr = img.getAttribute("width")
    const heightAttr = img.getAttribute("height")

    if (widthFromStyle) {
      img.style.setProperty("width", widthFromStyle, "important")
    } else if (widthAttr && !widthAttr.endsWith("%")) {
      img.style.setProperty("width", `${widthAttr}px`, "important")
    }

    if (heightFromStyle) {
      img.style.setProperty("height", heightFromStyle, "important")
    } else if (heightAttr && !heightAttr.endsWith("%")) {
      img.style.setProperty("height", `${heightAttr}px`, "important")
    }

    if (widthFromStyle || widthAttr || heightFromStyle || heightAttr) {
      img.style.setProperty("max-width", "none", "important")
      img.style.setProperty("object-fit", "contain", "important")

      const container = img.closest('[data-resize-container][data-node="image"]')
      if (container instanceof HTMLElement) {
        container.style.setProperty("width", "fit-content", "important")
        container.style.setProperty("max-width", "none", "important")
      }
    }
  })
}
